import { PrimitiveAtom, useAtom } from 'jotai';

type useTabNavigationSetterProps = {
  tabsAtom: PrimitiveAtom<string>;
  routeToSet: string;
};

export const useTabNavigationSetter = ({ tabsAtom, routeToSet }: useTabNavigationSetterProps) => {
  const [currentRote, setRoute] = useAtom(tabsAtom);
  if (currentRote !== routeToSet) {
    setRoute(routeToSet);
  }
};
